import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import homeLogo from "../../logo/logo.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import {
  AiFillGithub,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { BsArrowRight } from "react-icons/bs";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 className="heading-name" style={{ fontSize: "2.8em", lineHeight: "1.3", paddingBottom: "20px" }}>
                We help <strong className="purple">SaaS founders, startups, SMBs, and enterprises ship faster</strong> by delivering dedicated developers and end-to-end software systems
              </h1>

              <div style={{ padding: "30px 0", textAlign: "left", fontSize: "1.6em" }}>
                <Type />
              </div>
              
              <p style={{ color: "rgb(155 126 172)", fontSize: "1.3em", paddingTop: "10px", lineHeight: "1.6" }}>
                <strong>Reduce backlog. Accelerate releases. Scale delivery without hiring overhead.</strong>
                <br />
                From <strong>ERP, CRM, AI automation</strong> to SaaS platforms and web apps, our developers integrate directly into your workflow for immediate productivity.
              </p>

              <div style={{ paddingTop: "30px", display: "flex", gap: "15px", flexWrap: "wrap", position: "relative", zIndex: 10 }}>
                <Link to="/about" style={{ textDecoration: "none" }}>
                  <Button variant="primary" className="quick-nav-btn">
                    About Us <BsArrowRight style={{ marginLeft: "5px" }} />
                  </Button>
                </Link>
                <Link to="/project" style={{ textDecoration: "none" }}>
                  <Button variant="primary" className="quick-nav-btn">
                    Our Projects <BsArrowRight style={{ marginLeft: "5px" }} />
                  </Button>
                </Link>
                <Link to="/reviews" style={{ textDecoration: "none" }}>
                  <Button variant="primary" className="quick-nav-btn">
                    Client Reviews <BsArrowRight style={{ marginLeft: "5px" }} />
                  </Button>
                </Link>
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>Connect With Us</h1>
            <p>
              Feel free to <span className="purple">reach out </span>to us
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/AffanAhmedUsmani"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="GitHub"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/affan-ahmed-0b859521a/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://wa.link/ov814n"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:send2affanahmed@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="Email"
                >
                  <AiOutlineMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
